$(document)
    .find('button[type=submit][value!=""]')
    .click(function (event) {
        event.preventDefault();

        const $submitButton = $(this);
        const $form = $submitButton.closest('form');
        $('<input/>').attr({
            type: 'hidden',
            name: $submitButton.attr('name'),
            value: $submitButton.val(),
        }).appendTo($form);

        $form.submit();
    });
